import React, { BaseSyntheticEvent } from 'react'
import { ModalForm } from '../../../shared/ui/ModalForm/ModalForm'
import { SubmitHandler, useForm } from 'react-hook-form'
import { appActions } from '../../../entities/Application'
import { modalActions } from '../../../entities/Modal'
import { useAppDispatch } from '../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { updateApp } from '../model/services/updateApp'
import Stack from '@mui/material/Stack'
import { AppNameInput } from './AppNameInput/AppNameInput'
import { AppExpDate } from './AppExpDate/AppExpDate'
import Typography from '@mui/material/Typography'
import { AppRight } from './AppRight/AppRight'

const inputStyles = {
	width: '19rem'
}
const style = {
	p: '2rem',
	width: 700
}

export const UpdateAppModal = () => {
	const dispatch = useAppDispatch()

	const {
		handleSubmit,
		control,
		register,
		reset,
		formState: { errors, isValid }
	} = useForm({ mode: 'onBlur' })

	const handleCancel = () => {
		dispatch(modalActions.hideModal())
		reset()
		dispatch(appActions.resetAppEditable())
	}

	const onSubmit: SubmitHandler<{}> = async (_, event) => {
		event?.preventDefault()
		const result = await dispatch(updateApp())
		if (result.meta.requestStatus === 'fulfilled') {
			dispatch(modalActions.hideModal())
			reset()
		}
	}

	return (
		<ModalForm
			styles={style}
			disabled={!isValid}
			handleCancel={handleCancel}
			modalTitle={'Edit application'}
			handleOnSubmit={(e: BaseSyntheticEvent) =>
				handleSubmit(onSubmit({}, e))
			}
		>
			<hr />
			<Typography
				variant="h6"
				sx={{ mb: '1rem' }}
			>
				General
			</Typography>
			<Stack direction="row" spacing={4}>
				<AppNameInput
					styles={inputStyles}
					register={register}
					validationErrors={errors}
				/>
				<AppExpDate
					styles={inputStyles}
					control={control as any}
				/>
			</Stack>
			<Typography
				variant="h6"
				sx={{ my: '1.5rem' }}
			>
				Application permissions
			</Typography>
			<Stack direction="row" gap={4} sx={{ mb: '1.5rem' }}>
				<AppRight
					label={'Clients'}
					labelId={'clients'}
					actionKey={'setClientsRights'}
					styles={inputStyles}
				/>
				<AppRight
					label={'Products'}
					labelId={'products'}
					actionKey={'setProductsRights'}
					styles={inputStyles}
				/>
			</Stack>
			<Stack direction="row" gap={4} sx={{ mb: '1.5rem' }}>
				<AppRight
					label={'Licenses'}
					labelId={'licenses'}
					actionKey={'setLicensesRights'}
					styles={inputStyles}
				/>
				<AppRight
					label={'Instances'}
					labelId={'instances'}
					actionKey={'setInstancesRights'}
					styles={inputStyles}
				/>
			</Stack>
			<Stack direction="row" gap={4}>
				<AppRight
					label={'Users'}
					labelId={'users'}
					actionKey={'setUsersRights'}
					styles={inputStyles}
				/>
			</Stack>
		</ModalForm>
	)
}